import React, { useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import WhiteListService from '../services/WhiteListService';
import { toast } from 'react-toastify';
import { Row, Form, Col, Input } from 'reactstrap';
import ReactButton from 'components/Buttons/ReactButton';
import DefaultModal from 'components/Modal/DefaultModal';

const CreateAndEditWhiteList = ({
  isModalOpen,
  onModalToggle,
  WhiteListFromUpdate,
  getWhiteList = () => {},
  ...props
}) => {
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);
  const { control, errors, watch, handleSubmit } = useForm();
  const onSubmit = async () => {
    try {
      const dto = {
        ip_origem: watch('ip_origem'),
        host: watch('host')
      };

      if (!dto.ip_origem && !dto.host) {
        toast.error(
          'Por favor, preencha pelo menos um dos campos: IP ou Domínio',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
        return;
      }

      if (!Object.keys(WhiteListFromUpdate || {}).length) {
        return await handlerCreateWhiteList(dto);
      }
      await updateWhiteList(dto);
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(err.response.data.message, {
          autoClose: 3000,
          closeOnClick: true
        });
      } else {
        toast.error('Erro ao criar WhiteList', {
          autoClose: 3000,
          closeOnClick: true
        });
      }
    }
  };

  const handlerTitle = () => {
    return WhiteListFromUpdate?.id
      ? 'Editar WhiteList'
      : 'Criar nova WhiteList';
  };

  const updateWhiteList = async ({ ip_origem, host }) => {
    if (!WhiteListFromUpdate?.id) throw new Error('Id não informado');
    await WhiteListService.update(WhiteListFromUpdate?.id, { ip_origem, host });
    getWhiteList();
    toast.success('WhiteList atualizada com sucesso', {
      autoClose: 3000,
      closeOnClick: true
    });
    closeModal();
  };

  const handlerCreateWhiteList = async ({ ip_origem, host }) => {
    await WhiteListService.create({ ip_origem, host });
    getWhiteList();

    toast.success('WhiteList criada com sucesso', {
      autoClose: 3000,
      closeOnClick: true
    });
    closeModal();
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title={handlerTitle()}
      showCloseButton={false}
      modalContainerClasses="modal-sm"
      {...props}
    >
      <>
        <Form className="needs-validation">
          <Row className="mb-3">
            <Col className="px-0">
              <Col sm="12" className="mb-3">
                <label className="form-control-label">Ip</label>
                <Controller
                  render={(props) => (
                    <Input
                      value={props.value}
                      type="text"
                      onChange={props.onChange}
                      placeholder="255.255.255.255"
                    />
                  )}
                  control={control}
                  name="ip_origem"
                  defaultValue={WhiteListFromUpdate?.ip_origem || ''}
                  rules={{
                    validate: (value) => {
                      if (!value) return true;
                      const ipRegex =
                        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
                      return ipRegex.test(value) || 'IP invalido';
                    }
                  }}
                />
                <ErrorMessage
                  errors={errors}
                  name="ip_origem"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col className="px-0">
              <Col sm="12" className="mb-3">
                <label className="form-control-label">Domínio</label>
                <Controller
                  render={(props) => (
                    <Input
                      value={props.value}
                      type="text"
                      onChange={props.onChange}
                      placeholder="example.com"
                    />
                  )}
                  control={control}
                  name="host"
                  defaultValue={WhiteListFromUpdate?.host || ''}
                />
                <ErrorMessage
                  errors={errors}
                  name="host"
                  render={({ message }) => errorFormMessage(message)}
                />
              </Col>
            </Col>
          </Row>
          <hr />
          <ReactButton btnColor="confirmation" onClick={handleSubmit(onSubmit)}>
            Salvar
          </ReactButton>
          <ReactButton btnColor="cancelation" onClick={closeModal}>
            Voltar
          </ReactButton>
        </Form>
      </>
    </DefaultModal>
  );
};

export default CreateAndEditWhiteList;
